// ONYX-CUSTOM: Any link whose URL ends in #open-chat opens the Zuzana chat widget instead of navigating
// Without the widget (not installed, still loading, or blocked) the click falls through and the link opens its page.
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href$="#open-chat"]');
  if (!link || typeof window.Zuzana?.open !== 'function') return;
  event.preventDefault();
  window.Zuzana.open();
});
